import { Box, CircularProgress } from '@mui/material';
import ClusterDbSocketProvider from 'components/hooks/ClusterDbSocketProvider';
import { AppLayout, AuthLayout } from 'components/layout';
import { PAGE_LIST } from 'constant/pages';
import { Dashboard, Home, Setting, UserDetail, VisitDetail } from 'pages';
import QueryString from 'qs';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { getUser } from 'utils/fetch';

function App() {
  const getTokenFromQueryStrAndGetAuth = async (str: string) => {
    const queryString = str.split('?')[1];
    const query = QueryString.parse(queryString);
    return await getUser(query?.accessToken as string | undefined);
  };

  const router = createBrowserRouter([
    {
      element: <AuthLayout />,
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      children: [
        {
          path: PAGE_LIST.SETTING.pathname(),
          element: <Setting />,
        },
      ],
    },
    {
      path: '/',
      element: <AppLayout />,
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      errorElement: <Navigate to={PAGE_LIST.SETTING.pathname()} />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: PAGE_LIST.DASHBOARD.pathname(),
          element: <Dashboard />,
        },
        {
          path: PAGE_LIST.USER_DETAIL.pathname(),
          element: <UserDetail />,
        },
        {
          path: PAGE_LIST.VISIT_DETAIL.pathname(),
          element: <VisitDetail />,
        },
      ],
    },
  ]);

  return (
    <ClusterDbSocketProvider>
      <RouterProvider
        router={router}
        fallbackElement={
          <Box
            sx={{
              width: '100%',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress sx={{ color: '#1A96F0' }} />
          </Box>
        }
      />
    </ClusterDbSocketProvider>
  );
}

export default App;
